import { Button, Modal } from "react-bootstrap";

const CategoryList = ({
  Show,
  Hide,
  Title,
  categoryList,
  isDark,
  toggles,
  setCategoryData,
}) => {
  return (
    <Modal show={Show} onHide={Hide} size="lg">
      <Modal.Header
        closeButton
        className={`${isDark ? "bg-dark text-light" : "bg-light"} p-3 border-bottom`}
      >
        <Modal.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={`rounded-bottom ${isDark ? "bg-dark" : "bg-white"}`}>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          {categoryList?.map((item, index) => (
            <button
              key={index}
              title={item?.name}
              onClick={() => {
                toggles?.setToggle();
                setCategoryData(item);
                Hide();
              }}
              className={`category-card ${isDark ? "dark" : ""}`}
            >
              <img src={item?.icon} alt={item?.name} />
              <div className="category-text">{item?.name}</div>
            </button>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CategoryList;
